import { MenuButtonData } from '../../system/Classes/MenuButtonData';

export const musicMenuData: Array<MenuButtonData> = [
    {display:"課程目標", path:"/courseTarget/musicObjectives"},
    {display:"校本課程特色", path:"/courseTarget/musicBase"},
    {display:"年度重點項目", path:"/courseTarget/musicConcern"},
    {display:"學生成果展示", path:"/courseTarget/musicDisplay"},
    {display:"教師專業發展", path:"/courseTarget/musicDevelopment"},
];
